import _ from 'lodash';
import {VError} from 'verror';

const ApiErrorName = 'API';
const EsetupErrorName = 'E-Setup';

function isStatusOk(response){
    const exception = _.get(response, 'headers.x-cba-exception', null);
    return Boolean(response && response.status === 200 && !exception);
}

function createApiError(response, cause) {
    if (!response && !cause) {
        return new Error('Unknown Error');
    }

    // extract info and header keys for the API error if any
    const correlationId = _.get(response, 'headers.x-cba-correlation-id', null);
    const errorCode = _.get(response, 'headers.x-cba-error-code', null);
    const statusCode = _.get(response, 'status', null);
    const text = _.get(response, 'data', cause && typeof cause.toString !== 'undefined' ? cause.toString() : null);
    const url = _.get(response, 'config.url', null);

    const options = {
        name: ApiErrorName,
        cause: cause ? cause : new Error('Response Status Code: ' + statusCode),
        info: {
            response: response,
            correlationId: correlationId,
            errorCode: errorCode,
            statusCode: statusCode,
            text: text,
            url: url
        }
    };

    return new VError(options, 'failed to call API');
}

module.exports = {
    getError: function(apiName, error) {
        const errorType = _.get(error, '__proto__.name', null);

        const cause = errorType === 'VError' ? error : createApiError(error.response, error);

        return new VError({
                name: EsetupErrorName,
                info: { 'API Name': apiName },
                cause: cause
            },
            '%s',
            apiName);
    },

    getApiErrorInfo: function(error) {
        let apiErrorInfo = {};
        if (!error) {
            return apiErrorInfo;
        }

        try {
            const apiError = VError.findCauseByName(error, ApiErrorName);
            if (apiError) {
                apiErrorInfo = VError.info(apiError)
            }
        } catch (err) {
            // suppress any error thrown by VError
        }
        return apiErrorInfo;
    },

    isStatusOk: isStatusOk,

    createApiError: createApiError,

    ThrowIfStatusNotOk: function(response) {
        if (!isStatusOk(response)) {
            throw createApiError(response);
        }

        return response;
    }
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./apis/ApiHelper.js